export default __webpack_public_path__ + "static/media/hht2_sitcom_13.fbf252b4.png";